"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeOfDeleteModal = exports.PayApplicationStatus = exports.PayAccountStatus = exports.CompanyBookingAllowances = exports.BusinessType = exports.BusinessQuestionWhenTo = exports.BusinessQuestionType = exports.BusinessQuestionDefaultQuestionId = exports.BusinessQuestionDefaultHeader = void 0;
var BusinessQuestionType = exports.BusinessQuestionType = function (BusinessQuestionType) {
  BusinessQuestionType["PurchaseOrder"] = "purchase_order_number";
  BusinessQuestionType["CustomerReference"] = "customer_reference";
  return BusinessQuestionType;
}({});
var BusinessQuestionDefaultHeader = exports.BusinessQuestionDefaultHeader = function (BusinessQuestionDefaultHeader) {
  BusinessQuestionDefaultHeader["PurchaseOrder"] = "Purchase order number";
  BusinessQuestionDefaultHeader["CustomerReference"] = "Customer reference";
  return BusinessQuestionDefaultHeader;
}({});
var BusinessQuestionDefaultQuestionId = exports.BusinessQuestionDefaultQuestionId = function (BusinessQuestionDefaultQuestionId) {
  BusinessQuestionDefaultQuestionId["PurchaseOrder"] = "2";
  BusinessQuestionDefaultQuestionId["CustomerReference"] = "1";
  return BusinessQuestionDefaultQuestionId;
}({});
var BusinessQuestionWhenTo = exports.BusinessQuestionWhenTo = function (BusinessQuestionWhenTo) {
  BusinessQuestionWhenTo["Register"] = "Register";
  BusinessQuestionWhenTo["Booking"] = "Booking";
  return BusinessQuestionWhenTo;
}({});
var TypeOfDeleteModal = exports.TypeOfDeleteModal = function (TypeOfDeleteModal) {
  TypeOfDeleteModal["Card"] = "Card";
  TypeOfDeleteModal["Question"] = "Question";
  return TypeOfDeleteModal;
}({});
var CompanyBookingAllowances = exports.CompanyBookingAllowances = function (CompanyBookingAllowances) {
  CompanyBookingAllowances["PIB"] = "premierInnBreakfast";
  CompanyBookingAllowances["CB"] = "continentalBreakfast";
  CompanyBookingAllowances["FCB"] = "freeChildBreakfast";
  CompanyBookingAllowances["MD"] = "mealDeal";
  CompanyBookingAllowances["HB"] = "hubBreakfast";
  CompanyBookingAllowances["UW"] = "ultimateWifi";
  return CompanyBookingAllowances;
}({});
var PayApplicationStatus = exports.PayApplicationStatus = function (PayApplicationStatus) {
  PayApplicationStatus["Started"] = "Incomplete application";
  PayApplicationStatus["Submitted"] = "Outstanding";
  PayApplicationStatus["Approved"] = "Accepted";
  PayApplicationStatus["Rejected"] = "Rejected";
  PayApplicationStatus["Cancelled"] = "Cancelled";
  return PayApplicationStatus;
}({});
var PayAccountStatus = exports.PayAccountStatus = function (PayAccountStatus) {
  PayAccountStatus["Active"] = "current";
  PayAccountStatus["Suspended"] = "stop";
  PayAccountStatus["SuspendedHold"] = "hold";
  PayAccountStatus["Closed"] = "closed";
  return PayAccountStatus;
}({});
var BusinessType = exports.BusinessType = function (BusinessType) {
  BusinessType["Charity"] = "Charity";
  BusinessType["GovernmentFundedSchool"] = "Government funded school";
  BusinessType["Government"] = "Government";
  BusinessType["LimitedCompany"] = "Limited company";
  BusinessType["Partnership"] = "Partnership";
  BusinessType["PublicLimited"] = "Public limited";
  BusinessType["SoleTrader"] = "Sole trader";
  BusinessType["Other"] = "Other";
  return BusinessType;
}({});